export const getSubdomain = () => {
  return window.location.hostname === 'tibetlocal.com' ||
    window.location.hostname === 'test.tibetpass.com' ||
    window.location.hostname === 'tibetpass.com'
    ? null
    : window.location.hostname.split('.')[0];
};
